import React from 'react'
import { connect } from 'react-redux'
import { open } from '../../state/accident-modal/actions'
import Link from '../Link/index.jsx'
import styled from 'styled-components'

import { Heading } from 'rebass'
import { Flex, Box } from 'rebass'

import { media } from '../../utils/style'
import CalltracksPhoneNumber from '../CalltracksPhoneNumber'

/*************************
 STYLES: Wrapper
 **************************/
const GreyBandWrapper = styled(Flex)`
  position: relative;
  background: ${(props) => props.theme.colors.blue};
  color: ${(props) => props.theme.colors.white};

  ${media.MediumScreenUp`
    padding-bottom: 30px;
    padding-top: 70px;
  `}
  a {
    text-decoration: none;
    font-weight: 400;
    color: rgba(238, 244, 249, 0.7);
    display: block;

    &:hover {
      color: ${(props) => props.theme.colors.white};
    }
  }
`

const Container = styled(Box)`
  position: relative;
  max-width: ${(props) => props.theme.content.max.width};
  margin-left: auto;
  margin-right: auto;
`

/*************************
 STYLES: Content
 **************************/
const Contact = styled(Box)`
  position: relative;
  line-height: 2.1em;
  text-align: left;
  border-top: 1px rgba(154, 163, 179, 0.3) solid;

  span {
    font-weight: 600;
    padding-right: 5px;
    color: ${(props) => props.theme.colors.blue_light};
  }

  a {
    display: inline;
    color: ${(props) => props.theme.colors.white};
  }

  img {
    position: absolute;
    right: 0;
    bottom: 32px;
    max-width: 75px;
    ${media.MediumScreenUp`
      bottom: 50px;
      max-width: 106px;
    `};
  }

  ${media.MediumScreenUp`
    text-align: right;
    border-top: none;
  `};
`

const SectionHeading = styled(Heading)`
  color: ${(props) => props.theme.colors.blue_light};
  font-weight: 600;
  text-transform: uppercase;

  a {
    text-decoration: none;
    color: ${(props) => props.theme.colors.blue_light};
    display: block;
    font-weight: 600;

    &:hover {
      color: ${(props) => props.theme.colors.white};
    }
  }
`

const LinkBox = styled(Box)`
  line-height: 1.2em;
  width: 150px;
  min-width: 45%;
  margin-right: 5%;
  ${media.MediumScreenUp`
    width: 45%;
    min-width: 0;
  `};
  ${media.GiantScreenUp`
    margin-right: 20px;
    width: 180px;
    min-width: 0;
  `};

  a {
    display: block;
    font-size: 14px;
    margin-bottom: 1em;
  }
`

const HelpLine = styled.a`
  font-weight: 600 !important;
  color: ${(props) => props.theme.colors.blue_light} !important;
  text-decoration: underline !important;

  &:hover {
    color: white !important;
  }
`

const FlexWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
`

class FooterLinks extends React.PureComponent {
  render() {
    const { sections, phoneNumber } = this.props

    let footerLinksConstruct = []

    sections.forEach(function (section) {
      let sectionMarkup = []
      // section headings
      sectionMarkup.push(
        <SectionHeading
          as="h6"
          fontSize={1}
          mb={2}
          key={`fsheading:${section.label}`}
        >
          {section.href ? (
            <Link
              activeClassName="active"
              to={section.href}
              key={`fslink:${section.label}`}
            >
              {section.label}
            </Link>
          ) : (
            section.label
          )}
        </SectionHeading>
      )
      // section page listing
      section.links.forEach((link) => {
        sectionMarkup.push(
          link.external ? (
            <a key={`fplink:${link.label}`} href={link.href}>
              {link.label}
            </a>
          ) : (
            <Link
              activeClassName="active"
              to={link.href}
              key={`fplink:${link.label}`}
            >
              {link.label}
            </Link>
          )
        )
      })

      footerLinksConstruct.push(
        <LinkBox
          flex={['1 1 auto']}
          px={['8px', 0]}
          pb={50}
          key={`fsbox:${section.label}`}
        >
          {sectionMarkup}
        </LinkBox>
      )
    })
    return (
      <GreyBandWrapper pt={[60, 70]} pb={[0, 30]}>
        <Container width={[10 / 12, 11 / 12]}>
          <FlexWrapper>
            <Box id="footer-category-links" width={[12 / 12, 9 / 12]}>
              <FlexWrapper>{footerLinksConstruct}</FlexWrapper>
            </Box>
            <Contact pt={[40, 0]} pb={[80, 0]} width={[12 / 12, 3 / 12]}>
              <div>
                <Link to="/locations">Contact us</Link>
              </div>
              <HelpLine onClick={this.props.onHadAnAccident}>
                Accident Helpline
              </HelpLine>
              <div>
                <Link to="/careers">We are Hiring!</Link>
              </div>
            </Contact>
          </FlexWrapper>
        </Container>
      </GreyBandWrapper>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  onHadAnAccident: () => dispatch(open())
})

export default connect(
  (state) => ({ phoneNumber: state.phoneNumber }),
  mapDispatchToProps
)(FooterLinks)
